import { useMemo, useState } from "react";
import { ICodename, IResource } from "../../../commons/interfaces";
import { AccessMode, ResourceType, RoleType } from "../../../constants/enums";
import ResourceService from "../../../services/identity/resourceService";
import ServiceService from "../../../services/identity/service.service";
import { useCommonComponentContext } from "../../../providers/CommonComponentProvider";
import { RoleHelpers } from "../../../commons/roleHelpers";

export const useSelectData = () => {
    const { userInfo } = useCommonComponentContext();
    const roleType = userInfo?.userProfile?.roleType;

    const [resources, setResources] = useState<IResource[]>([]);

    const [services, setServices] = useState<ICodename[]>([]);

    const roleTypeList = useMemo<ICodename[]>(() => {
        const isServiceSet = RoleHelpers.isServiceSet(roleType);
        const result = [
            { code: RoleType.Owner, name: "Owner" },
            { code: RoleType.Admin, name: "Admin" },
            { code: RoleType.GroupAdmin, name: "Group Admin" },
            { code: RoleType.Member, name: "Member" },
            { code: RoleType.Custom, name: "Other" },
            { code: RoleType.Default, name: "Default" },
        ];
        return isServiceSet ? result : result.splice(0, result.length - 1);
    }, [roleType]);

    const roleGroup = [
        {
            code: RoleType.Service,
            name: "Service",
        },
        {
            code: RoleType.TenantOrMembership,
            name: "Tenant",
        },
        {
            code: RoleType.Normal,
            name: "Normal",
        },
        {
            code: RoleType.User,
            name: "User",
        },
    ];

    const getAllService = async (searchText?: string) => {
        try {
            let listTemp: ICodename[] = [];
            const result = await ServiceService.getAll({ searchText: searchText });
            result.forEach((e: any) => {
                listTemp.push({
                    code: e.serviceCode,
                    name: e.serviceName,
                });
            });
            setServices(listTemp);
        } catch (error) {}
    };

    const getAllResource = async (serviceCode: string) => {
        try {
            const result = await ResourceService.getAll({
                serviceCode: serviceCode,
                resourceType: [ResourceType.Module],
                accessMode: AccessMode.PrivateRBAC,
            });
            setResources(result);
        } catch (error) {}
    };

    return {
        resources,
        services,
        roleGroup,
        roleTypeList,
        getAllResource,
        getAllService,
        setResources,
    };
};

export default useSelectData;
